import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
// import 'bootstrap/dist/css/bootstrap.min.css';

const RedirectToBlogs = () => {
  const [seconds, setSeconds] = useState(25);
  const navigate = useNavigate();

  useEffect(() => {
    // If countdown reaches 0, navigate to /blogs
    if (seconds <= 0) {
      navigate('/blogs');
      return;
    }
    // Set up the interval to decrement the countdown
    const intervalId = setInterval(() => {
      setSeconds(prev => prev - 1);
    }, 1000);

    // Clean up the interval on component unmount or when seconds changes
    return () => clearInterval(intervalId);
  }, [seconds, navigate]);

  return (
    // <div className="container vh-100 d-flex justify-content-center align-items-center bg-light">
      <div className="card shadow-sm bg-dark text-white">
        <div className="card-body text-center">
          <h1 className="card-title">Redirecting to Other Available Blogs</h1>
          <p className="card-text">
            You will be redirected to <strong>/blogs</strong> in <span>{seconds}</span> seconds.
          </p>
        </div>

      </div>
    // </div>
  );
};

export default RedirectToBlogs;
